import React from 'react';
import { Clock, DollarSign, Leaf } from 'lucide-react';
import { Card } from './ui/card';

const USPs = () => {
  const usps = [
    {
      icon: Clock,
      title: "RAPIDE",
      description: "Délais serrés et respectés",
      details: "Livraison en 24h après validation",
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: DollarSign,
      title: "SIMPLE & ÉCONOMIQUE",
      description: "Transports et volumes adaptés",
      details: "Tarifs tout compris sans surprise",
      color: "from-green-500 to-green-600"
    },
    {
      icon: Leaf,
      title: "ÉCO-RESPONSABLE",
      description: "Favorisant le recyclage",
      details: "Déchets revalorisés en centre agréé",
      color: "from-emerald-500 to-emerald-600"
    }
  ];

  return (
    <section id="engagements" className="py-16 bg-white scroll-mt-28" data-testid="engagements-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Nos engagements
          </h2>
          <p className="text-xl text-gray-600">
            Un service complet pour une gestion optimale de vos déchets
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {usps.map((usp, index) => (
            <Card
              key={index}
              className="p-8 text-center hover:shadow-xl transition-all duration-300 border-0 shadow-md group cursor-pointer"
            >
              <div className="mb-6 inline-flex">
                <div className={`bg-gradient-to-br ${usp.color} p-4 rounded-2xl group-hover:scale-110 transition-transform duration-300`}>
                  <usp.icon className="h-8 w-8 text-white" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {usp.title}
              </h3>
              <p className="text-gray-700 font-medium mb-2">
                {usp.description}
              </p>
              <p className="text-gray-600 text-sm">
                {usp.details}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USPs;